import { useTheme } from '@mui/material/styles';
import { componentPresets } from './unifiedTheme';

/**
 * Hook to access unified theme styles in components
 * 
 * @example
 * const { card, button, container, text } = useThemeStyles();
 * 
 * <Card sx={card.default}>
 *   <Typography sx={text.sectionTitle}>Title</Typography>
 * </Card>
 */
export const useThemeStyles = () => {
  const theme = useTheme();
  
  return {
    // Direct access to preset styles
    card: componentPresets.card,
    button: componentPresets.button,
    container: componentPresets.container,
    text: componentPresets.text,
    
    // Common layout patterns
    layout: {
      flexBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      flexColumn: {
        display: 'flex',
        flexDirection: 'column',
      },
      flexRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
      grid: {
        display: 'grid',
        gap: theme.spacing(3),
      },
    },
    
    // Spacing helpers
    spacing: {
      page: { p: 3 },
      section: { mb: 4 },
      card: { p: 3 },
      compact: { p: 2 },
      coupleProfile: { p: 2 },
      coupleProfileCard: { p: 2, '&:last-child': { pb: 2 } },
    },
    
    // Common patterns
    patterns: {
      // Page header with title and action
      pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
      },
      
      // Empty state
      emptyState: {
        textAlign: 'center',
        py: 8,
        color: 'text.secondary',
      },
      
      // Loading state
      loadingState: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      },
      
      // Form container
      formContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
      },
    },
  };
};

export default useThemeStyles;